import React from "react";
import { useParams } from "react-router-dom";
import { FaCommentAlt, FaClock, FaFolder } from "react-icons/fa";
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_blog, get_comments } from "../../../service/api/blog";
import { formatDate, formatDateTime } from "../../../service/convert/date";
import HeaderTitle from "../../../components/ui/title";
import CreateComment from "../misc/CreateComment";
import LikeBlog from "../misc/LikeBlog";

const ViewBlog = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const blog = useAppSelector(({ blog }) => blog.blog);
  const comments = useAppSelector(({ blog }) => blog.comments);

  React.useEffect(() => {
    if (id) {
      get_blog(dispatch, id);
      get_comments(dispatch, id);
    }
  }, [dispatch, id]);

  const date = blog?.created_at ? formatDate(blog.created_at) : "";

  return (
    <div className="w-full bg-white min-h-screen">
      <div className="max-w-7xl mx-auto pt-32 px-6 xl:px-0 pb-10 md:pb-20 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <div className="mb-6">
            <HeaderTitle title={blog?.title || ""} />

            <div className="flex flex-wrap items-center text-gray-500 gap-4 mt-2">
              <span className="flex items-center">
                <FaClock className="mr-2 text-gray-400" />
                {date}
              </span>
              <span className="flex items-center">
                <FaFolder className="mr-2 text-gray-400" />
                {blog?.category?.name || "Uncategorized"}
              </span>
            </div>
          </div>

          {blog?.image && (
            <div className="mb-8 overflow-hidden rounded-lg shadow-md">
              <img
                src={blog.image}
                alt={blog?.title}
                className="w-full max-h-[32rem] object-cover rounded-lg"
              />
            </div>
          )}

          <div className="mb-10 prose prose-lg max-w-none">
            <div
              className="text-gray-800"
              style={{ textAlign: "justify" }}
              dangerouslySetInnerHTML={{ __html: blog?.article || "" }}
            />
          </div>

          <div className="flex justify-between items-center mb-8 pb-6 border-b border-gray-50/20">
            <div className="flex items-center gap-4">
              <LikeBlog count={blog?.likes_count?.toString() || "0"} />
              <div className="flex items-center">
                <FaCommentAlt className="mr-2 text-blue-500" />
                <span>{blog?.comments_count || 0}</span>
              </div>
            </div>
          </div>

          <div className="mb-8">
            <h3 className="text-2xl font-bold mb-6">
              Comments ({comments.length})
            </h3>
            {comments.length > 0 ? (
              <div className="space-y-6">
                {comments.map((comment) => (
                  <div
                    key={comment.id}
                    className="bg-gray-50 p-4 rounded-lg shadow-sm"
                  >
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0">
                        <img
                          src={comment?.user?.profile?.avatar}
                          alt={comment.user?.profile?.name || "User"}
                          className="w-12 h-12 rounded-full object-cover border-2 border-gray-200"
                        />
                      </div>
                      <div className="flex-grow">
                        <h6 className="font-semibold text-gray-900">
                          {comment?.user?.profile?.name || "Anonymous"}
                        </h6>
                        <p className="text-sm text-gray-500">
                          {comment?.created_at &&
                            formatDateTime(comment.created_at)}
                        </p>
                        <p className="mt-2 text-gray-700">{comment.comment}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-gray-50/20 p-6 rounded-lg text-center">
                <p className="text-gray-500">
                  No comments yet. Be the first to comment!
                </p>
              </div>
            )}
          </div>

          <div className="mt-8">
            <CreateComment />
          </div>
        </div>

        <div className="lg:col-span-1">
          <div className="sticky top-32 bg-gray-50/20 p-6 rounded-lg shadow-sm">
            <h3 className="text-xl font-bold mb-4 text-gray-900">
              Related Content
            </h3>
            <div className="space-y-4">
              {/* Content for sidebar can be added here */}
              <p className="text-gray-700">
                Additional blog information or related posts could be displayed
                here.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBlog;
